import travelClient from './travelClient';
import { travelEndpoints } from './endpoints';

function parseTravelJson(raw) {
  if (typeof raw !== 'string' || !raw) return raw;
  const text = raw.replace(
    /("(?:commentId|parentCommentId|rootCommentId|authorMemberId|publicationId)"\s*:\s*)(\d{15,})/g,
    '$1"$2"',
  );
  return JSON.parse(text);
}

const snowflakeJson = { transformResponse: [parseTravelJson] };

export const journeyCommentApi = {
  listComments: (publicationId, params) => travelClient.get(
    travelEndpoints.publicJourneyComments(publicationId),
    { params, ...snowflakeJson },
  ),
  createComment: (publicationId, body) => travelClient.post(
    travelEndpoints.publicJourneyComments(publicationId),
    body,
    snowflakeJson,
  ),
  listReplies: (publicationId, commentId, params) => travelClient.get(
    travelEndpoints.publicJourneyReplies(publicationId, commentId),
    { params, ...snowflakeJson },
  ),
  createReply: (publicationId, commentId, body) => travelClient.post(
    travelEndpoints.publicJourneyReplies(publicationId, commentId),
    body,
    snowflakeJson,
  ),
  editComment: (publicationId, commentId, body) => travelClient.patch(
    travelEndpoints.publicJourneyComment(publicationId, commentId),
    body,
    snowflakeJson,
  ),
  deleteComment: (publicationId, commentId, body) => travelClient.post(
    travelEndpoints.publicJourneyCommentDelete(publicationId, commentId),
    body,
    snowflakeJson,
  ),
};
